<template>
  <b-row>
    <b-col>
      <b-row v-if="isLoading">
        <b-col>
          <Loader size="lg"></Loader>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
              <template>
                <b-row>
                  <b-col>
                    <button type="button" class="btn btn-link fa fa-file-invoice-dollar fa-lg float-right" v-b-tooltip.hover :title="$t('buttons.createInvoice')" aria-hidden="true" @click="toggleInvoiceCreateModal()"></button>
                    <div v-if="items.length > 0">
                      <table class="table table-sm table-striped table-hover">
                        <thead>
                        <tr>
                          <th>{{ $t('views.exsbinvoices.list.invoiceType') }}</th>
                          <th>{{ $t('views.exsbinvoices.list.number') }}</th>
                          <th>{{ $t('views.appconfiguration.invoiceConfiguration.invoiceComment') }}</th>
                          <th>{{ $t('views.exsbinvoices.list.issueDate') }}</th>
                          <th>{{ $t('views.exsbinvoices.list.paymentDeadline') }}</th>
                          <th>{{ $t('views.exsbinvoices.list.valueBrutto') }}</th>
                          <th>{{ $t('views.exsbinvoices.list.totalValueNetto') }}</th>
                          <th>{{ $t('views.exsbinvoices.list.toPay') }}</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items" :key="item['@id']">
                          <td>
                              {{ item['invoiceType'].name }}
                          </td>
                          <td>
                            <router-link
                              :to="{name: 'EXSBInvoiceShow', params: { id: item['@id'] }}"
                              v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true">{{item.number || $t('views.agreements.list.noNumber')}}
                            </router-link>
                          </td>
                          <td>
                            {{item.comments}}
                          </td>
                          <td>
                              {{ item['issueDate'] }}
                          </td>
                          <td>
                            {{ $moment(item['paymentDeadline']).format('YYYY-MM-DD') }}
                          </td>
                          <td>
                            {{ item.totalValueBrutto.toFixed(2) }}
                          </td>
                          <td>
                            {{ item.totalValueNetto.toFixed(2) }}
                          </td>
                          <td>
                            <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '1'"><span class="text-danger">{{ $t('global.noPayment') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                            <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '2'"><span class="text-success">{{ $t('global.paymentFull') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                            <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '3'"><span class="text-warning">{{ $t('global.paymentPartial') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                            <b-badge v-if="item.idReceipt" variant="danger">
                              {{ $t('global.documentHasReceipt') }}
                            </b-badge>
                          </td>
                          <td>
                            <div class="btn-group">
                              <button
                                type="button"
                                class="btn btn-link fa fa-search fa-lg"
                                v-b-tooltip.hover :title="$t('buttons.show')"
                                @click="toggleInvoiceShowModal(item)" aria-hidden="true"></button>
                              <router-link
                                tag="button"
                                class="btn btn-link fa fa-edit fa-lg"
                                :to="{name: 'EXSBInvoiceUpdate', params: {id: item['@id']}}"
                                v-b-tooltip.hover :title="$t('buttons.edit')"
                                aria-hidden="true"></router-link>
                            </div>
                          </td>
                          <td></td>
                        </tr>
                        <tr v-if="items.length > 0 && totalSums && totalSums.length > 0">
                          <td colspan="5">{{ $t('views.agreements.form.total') }}</td>
                          <td>{{ totalSums[0].sumTotalValueBrutto }}</td>
                          <td>{{ totalSums[0].sumTotalValueNetto }}</td>
                          <td colspan="2">{{ totalSums[0].sumToPay }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <p v-else>{{ $t('views.exsbinvoices.list.noInvoices') }} </p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div v-if="view">
                      <pagination
                        :view="view"
                        @getPage="getPage($event)"
                      ></pagination>
                    </div>
                  </b-col>
                </b-row>
              </template>
        </b-col>
      </b-row>
      <b-row v-if="!firmIRI">
        <b-col>
          <router-link :to="{ name: 'EXSBInvoiceCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <InvoiceShowModal></InvoiceShowModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../../Layout/Loader'
import Pagination from '../../../../Layout/Pagination'
import getId from '@/utils/getIdFromLink'
import InvoiceShowModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/InvoiceShowModal'

export default {
  data () {
    return {
    }
  },
  components: {
    Loader,
    Pagination,
    InvoiceShowModal
  },

  props: {
    firmIRI: {
      type: String,
      default: null
    }
  },

  computed: mapGetters({
    deletedItem: 'exsbinvoice/del/deleted',
    error: 'exsbinvoice/list/error',
    items: 'exsbinvoice/list/items',
    isLoading: 'exsbinvoice/list/isLoading',
    view: 'exsbinvoice/list/view',
    totalSums: 'exsbinvoice/list/totalSums'
  }),

  beforeCreate () {
    checkPagePermission('finances', 'EXSBInvoiceList')
  },

  watch: {
    items: function (itemsList) {
      for (let i in itemsList) {
        itemsList[i].issueDate = this.$moment(itemsList[i].issueDate).format('YYYY-MM-DD')
      }
    }
  },

  created () {
    this.getList()
    this.channelBusinessInvoice = this.$store.state.Pusher.subscribe('e_x_s_b_invoices')
    this.channelBusinessInvoice.bind('e_x_s_b_invoices', data => {
      this.getList()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_invoices')
  },

  methods: {
    toggleInvoiceShowModal (item) {
      this.fetchInvoiceAsPDF(getId(item['@id']))
      this.setInvoiceNumber(item.number)
      this.toggleModal()
    },

    getList () {
      if (this.firmIRI) {
        let url = 'e_x_s_b_invoices?idUserData=' + getId(this.firmIRI)
        this.getPage(url)
      } else {
        this.getPage()
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    ...mapMutations({
      toggleModal: 'exsbinvoice/showModal/toggleModal',
      setInvoiceNumber: 'exsbinvoice/showModal/setInvoiceNumber',
      toggleInvoiceCreateModal: 'exsbinvoice/createModal/toggleModal'
    }),
    ...mapActions({
      getPage: 'exsbinvoice/list/getItems',
      fetchInvoiceAsPDF: 'exsbinvoice/showModal/fetchInvoiceAsPDF'
    })
  }
}
</script>
